// @flow
import { Record } from "immutable";

export type InstructorRecordInterface = {
  id: string,
  firstName: string,
  lastName: string,
  number: string,
  slug: string,
};

const InstructorRecord = Record({
  id: "",
  firstName: "",
  lastName: "",
  number: "",
  slug: "",
});

export default InstructorRecord;
